import { Mail, Phone } from "lucide-react";

const ContactSection = () => {
  return (
    <section id="contato" className="py-16 border-b border-border bg-card/50">
      <div className="container mx-auto px-6">
        <h2 className="text-3xl font-bold text-center mb-10 text-foreground">Contato</h2>
        <div className="flex flex-col md:flex-row items-center justify-center gap-8 md:gap-16">
          <a
            href="mailto:agenciaad4you@gmail.com"
            className="flex items-center gap-3 text-muted-foreground hover:text-foreground transition-colors"
          >
            <Mail className="w-5 h-5 text-primary" />
            <span className="text-sm">agenciaad4you@gmail.com</span>
          </a>
          <a
            href="https://wa.me/5519988278133"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-3 text-muted-foreground hover:text-foreground transition-colors"
          >
            <Phone className="w-5 h-5 text-primary" />
            <span className="text-sm">(19) 98827-8133</span>
          </a>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
